var _rect, _mask, _path, _rect2, _path2, _path3, _ellipse, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBattery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 68,
    rx: 16,
    fill: "#F7F9FA"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_21715_234319",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8047 16.2344C8.38641 16.2344 4.80469 19.8161 4.80469 24.2344V43.7583C4.80469 48.1765 8.3864 51.7583 12.8047 51.7583H49.3311C53.4035 51.7583 56.7652 48.7154 57.2666 44.7793H59.1931C61.4022 44.7793 63.1931 42.9885 63.1931 40.7793V27.2045C63.1931 24.9953 61.4022 23.2045 59.1931 23.2045H57.2655C56.7601 19.2726 53.4004 16.2344 49.3311 16.2344H12.8047Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.2666 44.7793V42.1793C55.9577 42.1793 54.8528 43.1523 54.6874 44.4508L57.2666 44.7793ZM57.2655 23.2045L54.6867 23.5359C54.8534 24.833 55.9576 25.8045 57.2655 25.8045V23.2045ZM7.40469 24.2344C7.40469 21.252 9.82235 18.8344 12.8047 18.8344V13.6344C6.95047 13.6344 2.20469 18.3802 2.20469 24.2344H7.40469ZM7.40469 43.7583V24.2344H2.20469V43.7583H7.40469ZM12.8047 49.1583C9.82235 49.1583 7.40469 46.7406 7.40469 43.7583H2.20469C2.20469 49.6125 6.95046 54.3583 12.8047 54.3583V49.1583ZM49.3311 49.1583H12.8047V54.3583H49.3311V49.1583ZM54.6874 44.4508C54.3493 47.105 52.078 49.1583 49.3311 49.1583V54.3583C54.729 54.3583 59.181 50.3259 59.8457 45.1079L54.6874 44.4508ZM59.1931 42.1793H57.2666V47.3793H59.1931V42.1793ZM60.5931 40.7793C60.5931 41.5525 59.9663 42.1793 59.1931 42.1793V47.3793C62.8382 47.3793 65.7931 44.4244 65.7931 40.7793H60.5931ZM60.5931 27.2045V40.7793H65.7931V27.2045H60.5931ZM59.1931 25.8045C59.9663 25.8045 60.5931 26.4313 60.5931 27.2045H65.7931C65.7931 23.5594 62.8382 20.6045 59.1931 20.6045V25.8045ZM57.2655 25.8045H59.1931V20.6045H57.2655V25.8045ZM49.3311 18.8344C52.0759 18.8344 54.3459 20.8845 54.6867 23.5359L59.8442 22.873C59.1743 17.6607 54.725 13.6344 49.3311 13.6344V18.8344ZM12.8047 18.8344H49.3311V13.6344H12.8047V18.8344Z",
    fill: "#CFD6D9",
    mask: "url(#path-2-inside-1_21715_234319)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.70312,
    y: 21.5977,
    width: 43.4525,
    height: 24.8017,
    rx: 6,
    fill: "#93EDBF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.70312 27.5977C9.70312 24.2839 12.3894 21.5977 15.7031 21.5977H31.4294V46.3994H15.7031C12.3894 46.3994 9.70312 43.7131 9.70312 40.3994V27.5977Z",
    fill: "#64E8A4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1293 43.4424C31.7458 43.5711 31.1143 43.5711 30.7308 43.4424C27.4603 42.3809 20.1523 37.9526 20.1523 30.4469C20.1523 27.1337 22.9605 24.4531 26.4228 24.4531C28.4753 24.4531 30.291 25.3967 31.4301 26.8549C32.5691 25.3967 34.3961 24.4531 36.4374 24.4531C39.8996 24.4531 42.7078 27.1337 42.7078 30.4469C42.7078 37.9526 35.3998 42.3809 32.1293 43.4424Z",
    fill: "#FF697A"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.3297,
    cy: 27.4046,
    rx: 1.1422,
    ry: 1.13706,
    fill: "#F5F5F5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9898 29.4801C40.1164 30.511 40.4729 33.7395 36.8329 36.8118",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBattery);
export default __webpack_public_path__ + "static/media/battery.2b06bd3490652d4d0dbf50347a4e2874.svg";
export { ForwardRef as ReactComponent };